import React, { Fragment } from 'react'
import { arrayOf, string, bool, shape } from 'prop-types'
import ThemeConsumer from '../ThemeConsumer'
import classNames from 'classnames'

const Definition = ({
  theme,
  items,
  showLabels,
  classNameCell,
  className,
  classTitle,
  title,
  keyClasses,
  valuesClasses,
  removeKey,
  removeTitle
}) => {
  const definitionClasses = classNames(
    'definition',
    showLabels ? theme.definition4box : theme.definition,
    className
  )

  const cellClasses = classNames(
    'definition__cell',
    classNameCell
  )

  return (
    <Fragment>
        {!removeTitle && <h1 className={classTitle}>{title}</h1>}
        <div className={definitionClasses}>
          {items.map(item => (
            <dl className={cellClasses} key={item.key}>
              {!removeKey && <dt className={keyClasses}>{item.key}</dt>}
              {item.value && <dd className={valuesClasses}>{item.value}</dd>}
              {item.icon && <dd className={valuesClasses}>{item.icon}</dd>}
            </dl>
          ))}
        </div>
    </Fragment>
  )}

Definition.propTypes = {
  theme: shape({ definition: string }),
  items: arrayOf(shape({
    key: string,
    value: string,
  })),
  showLabels: shape({ definition: bool }),
  title: shape({ definition: string }),
  removeKey: bool,
  removeTitle: bool,
}

Definition.defaultProps = {
  theme: {},
  items: [],
  showLabels: false,
  title: null,
  removeKey: false,
  removeTitle: false
}

export default ThemeConsumer('UIDefinition')(Definition)



// WEBPACK FOOTER //
// ./src/shared/components/List/Definition.js